// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4112":"a3ede44e6a0beb25","4817":"a101d48440782d5f","5391":"aad7f82e0956ea6a","7140":"a7423aeeee0005d7","8787":"a1e3a7d3afb0d21c"}[chunkId] + ".css";
};